<template>
  <div class="box">
    <div class='lticon'></div>
    <div class="key">{{ info.key }}</div>
    <div class="val">
      <span>{{ info.val }}</span>
      <span class="unit">{{ ' ' + info.unit }}</span>
      <div class='statusicon1' :class="[info.color]"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
$height: 0.15rem;
.box {
  position: relative;
  width: 0.7rem;
  height: 0.3rem;
  color: #151a86;
  font-weight:500;
  padding-left: .08rem;
}
.lticon{
  position: absolute;
  font-size: 0.01rem;
  width: 0.08rem;
  height: 0.08rem;
  line-height: .08rem;
  left: 0;
  background-image: url(../img/arrow.png);
  background-size: 80% 60%;
  background-position: center center;
  background-repeat: no-repeat;
}
.key{
  font-size: 0.01rem;
  height: 0.12rem;
  line-height: .08rem;
  border-bottom: 1px dashed #151a86;
  font-weight:500;
  margin-bottom: .04rem;
  white-space: nowrap;
    overflow: inherit;
}
.val{
  font-size: 0.07rem;
}
.unit{
  font-size: 0.07rem;
  zoom: .7;
}
.statusicon1{
  float: right;
  width: .1rem;
  height: .1rem;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.red {
  color: #fb7a8e;
  background-image: url(../img/x.png);
}
.green {
  color: #37baca;
  background-image: url(../img/duigou.png);
}

</style>



// WEBPACK FOOTER //
// src/components/webgl/ui/valstatus/card2.vue